import { render, staticRenderFns } from "./TabelaCoparticipacao.vue?vue&type=template&id=1c1e4eb5&scoped=true&"
import script from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
export * from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaCoparticipacao.vue?vue&type=style&index=0&id=1c1e4eb5&scoped=true&lang=css&"
import style1 from "./TabelaCoparticipacao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e4eb5",
  null
  
)

export default component.exports